const BusinessActionTypes = {
    FETCH_BUSINESS_START: "FETCH_BUSINESS_START",
    FETCH_BUSINESS_SUCCESS: "FETCH_BUSINESS_SUCCESS",
    FETCH_BUSINESS_FAILURE: "FETCH_BUSINESS_FAILURE",
    SET_BUSINESS_SETTINGS: "SET_BUSINESS_SETTINGS",
    SET_TESTIMONALS: "SET_TESTIMONALS",
    SET_RESTAURANT_ID: "SET_RESTAURANT_ID",
}

export default BusinessActionTypes; 